(function () {
  window.ModifyHealth = window.ModifyHealth || {};

  window.ModifyHealth.Sentry = {
    captureException: function (err) {
      if (typeof Sentry !== 'undefined') {
        Sentry.captureException(err);
      }
    },
  };
})();
